import styles from './OfficeAppsSidebar.module.css'

const OFFICE_APPS = [
  {
    id: 'outlook',
    label: 'Outlook',
    icon: 'https://res.public.onecdn.static.microsoft/owamail/hashed-v1/resources/images/Mail_22px-hash-ef494f7f.m.svg',
  },
  {
    id: 'calendar',
    label: 'Calendar',
    icon: 'https://res.public.onecdn.static.microsoft/owamail/hashed-v1/resources/images/Calendar_22px-hash-4b5e2360.m.svg',
  },
  {
    id: 'onedrive',
    label: 'OneDrive',
    icon: 'https://res.public.onecdn.static.microsoft/owamail/hashed-v1/resources/images/onedrive_24x-hash-e0d279de.m.svg',
    active: true,
  },
  {
    id: 'word',
    label: 'Word',
    icon: 'https://res-1.public.onecdn.static.microsoft/files/fabric-cdn-prod_20260113.001/assets/brand-icons/product/svg/word_20x1.svg',
  },
  {
    id: 'excel',
    label: 'Excel',
    icon: 'https://res-1.public.onecdn.static.microsoft/files/fabric-cdn-prod_20260113.001/assets/brand-icons/product/svg/excel_20x1.svg',
  },
  {
    id: 'powerpoint',
    label: 'PowerPoint',
    icon: 'https://res-1.public.onecdn.static.microsoft/files/fabric-cdn-prod_20260113.001/assets/brand-icons/product/svg/powerpoint_20x1.svg',
  },
  {
    id: 'teams',
    label: 'Teams',
    icon: 'https://res-1.public.onecdn.static.microsoft/files/fabric-cdn-prod_20260113.001/assets/brand-icons/product/svg/teams_20x1.svg',
  },
  {
    id: 'people',
    label: 'People',
    icon: 'https://res.public.onecdn.static.microsoft/owamail/hashed-v1/resources/images/People_22px-hash-6b8f0c5c.m.svg',
  },
  {
    id: 'todo',
    label: 'To Do',
    icon: 'https://res-1.public.onecdn.static.microsoft/files/fabric-cdn-prod_20260113.001/assets/brand-icons/product/svg/todo_20x1.svg',
  },
]

export function OfficeAppsSidebar() {
  return (
    <aside className={styles.appsSidebar}>
      <nav className={styles.appsNav}>
        {OFFICE_APPS.map((app) => (
          <button
            key={app.id}
            className={`${styles.appButton} ${'active' in app && app.active ? styles.activeApp : ''}`}
            title={app.label}
          >
            <img src={app.icon} alt={app.label} className={styles.appIcon} />
          </button>
        ))}
      </nav>
    </aside>
  )
}
